import { call, put } from "redux-saga/effects";
import * as apis from "../../../network/apis/FlashCards/topics";
import messages from "../../../assets/locale/messages";
import { showHideSnackbar } from "../../Snackbar/actions";
import {
  deleteFlashCardSubTopicResponse,
  deleteFlashCardTopicResponse,
  editFlashCardSubTopicResponse,
  editFlashCardTopicResponse,
  getAllFlashCardSubTopicsRequest,
  getAllFlashCardSubTopicsResponse,
  getAllFlashCardTopicsRequest,
  getAllFlashCardTopicsResponse,
  getSingleFlashCardSubTopicResponse,
  getSingleFlashCardTopicResponse
} from "./actions";

export function* AddFlashCardTopicSaga({ payload }) {
  try {
    const response = yield call(apis.addFlashCardTopic, payload);
    yield put(getAllFlashCardTopicsRequest());
    yield put(
      showHideSnackbar({
        isOpen: true,
        type: "success",
        message:
          messages[response.lang].flashCard.topic.addTopicSuccess
      })
    );
  } catch (err) {
    console.error(err);
  }
}

let hasMore = true;
export function* GetAllFlashCardTopicsSaga({ payload }) {
  try {
    const page = payload?.page;
    console.log("hasMore page", page);

    if (!hasMore) return;

    const response = yield call(apis.getAllFlashCardTopic, payload);
    const meta = {
      currentPage: +response.headers["current-page"],
      count: +response.headers["total-count"],
      pages: +response.headers["total-pages"]
    };

    hasMore = page < meta?.pages;

    console.log("hasMore", hasMore);
    console.log("hasMore meta.pages", meta.pages);

    yield put(
      getAllFlashCardTopicsResponse({
        page,
        list: response.data.flashcard_topics || [],
        hasMore,
        meta
      })
    );
  } catch (err) {
    console.error(err);
  }
}

export function* GetSingleFlashCardTopicSaga({ payload }) {
  try {
    const response = yield call(
      apis.getSingleFlashCardTopic,
      payload
    );
    yield put(getSingleFlashCardTopicResponse(response.data.topic));
  } catch (err) {
    console.error(err);
  }
}

export function* EditFlashCardTopicSaga({ payload }) {
  try {
    const response = yield call(apis.editFlashCardTopic, payload);
    yield put(editFlashCardTopicResponse(payload));
    yield put(
      getAllFlashCardTopicsRequest({
        page: 1,
        items: 10,
        paginate: true
      })
    );
    yield put(
      showHideSnackbar({
        isOpen: true,
        type: "success",
        message:
          messages[response.lang].flashCard.topic.editTopicSuccess
      })
    );
  } catch (err) {
    console.error(err);
  }
}

export function* DeleteFlashCardTopicSaga({ payload }) {
  try {
    const response = yield call(apis.deleteFlashCardTopic, payload);
    yield put(deleteFlashCardTopicResponse(payload));
    yield put(
      showHideSnackbar({
        isOpen: true,
        type: "success",
        message:
          messages[response.lang].flashCard.topic.deleteTopicSuccess
      })
    );
  } catch (err) {
    console.error(err);
  }
}

// sub-topics
export function* GetAllFlashCardSubTopicsSaga({ payload }) {
  try {
    const { page } = payload;
    const response = yield call(
      apis.getAllFlashCardSubTopics,
      payload
    );
    const meta = {
      currentPage: +response.headers["current-page"],
      count: +response.headers["total-count"],
      pages: +response.headers["total-pages"]
    };
    const hasMore = page < meta.pages;

    yield put(
      getAllFlashCardSubTopicsResponse({
        topicId: payload.topicId,
        page,
        subTopicsList: response.data.flashcard_sub_topics || [],
        hasMore,
        meta
      })
    );
  } catch (err) {
    console.error(err);
  }
}

export function* AddFlashCardSubTopicSaga({ payload }) {
  try {
    const response = yield call(apis.addFlashCardSubTopics, payload);
    yield put(
      getAllFlashCardSubTopicsRequest({
        topicId: payload.topicId,
        page: 1,
        items: 10,
        paginate: true
      })
    );
    yield put(
      showHideSnackbar({
        isOpen: true,
        type: "success",
        message:
          messages[response.lang].flashCard.subTopic
            .addSubTopicSuccess
      })
    );
  } catch (err) {
    console.error(err);
  }
}

export function* GetSingleFlashCardSubTopicSaga({ payload }) {
  try {
    const response = yield call(
      apis.getSingleFlashCardSubTopic,
      payload
    );
    yield put(
      getSingleFlashCardSubTopicResponse(
        response.data.flashcard_sub_topic
      )
    );
  } catch (err) {
    console.error(err);
  }
}

export function* EditFlashCardSubTopicSaga({ payload }) {
  try {
    const response = yield call(apis.editFlashCardSubTopic, payload);
    yield put(editFlashCardSubTopicResponse(payload));
    yield put(
      getAllFlashCardSubTopicsRequest({
        topicId: payload.topicId,
        page: 1,
        items: 10,
        paginate: true
      })
    );
    yield put(
      showHideSnackbar({
        isOpen: true,
        type: "success",
        message:
          messages[response.lang].flashCard.subTopic
            .editSubTopicSuccess
      })
    );
  } catch (err) {
    console.error(err);
  }
}

export function* DeleteFlashCardSubTopicSaga({ payload }) {
  try {
    const response = yield call(
      apis.deleteFlashCardSubTopic,
      payload
    );
    yield put(deleteFlashCardSubTopicResponse(payload.id));
    yield put(
      showHideSnackbar({
        isOpen: true,
        type: "success",
        message:
          messages[response.lang].flashCard.subTopic
            .deleteSubTopicSuccess
      })
    );
  } catch (err) {
    console.error(err);
  }
}
